import {
    CheckoutOrder,
    Market,
    OrderType,
    PaymentForm,
    Price,
    ProductOrderItem,
} from "tm-shared/types";

interface BuildOfflineCheckoutOrderProps {
    productsArr: ProductOrderItem[];
    currentPriceList: Record<string, Price>;
    market: Market;
    orderId: string;
    paymentForm: PaymentForm;
    orderType: OrderType;
}

export const buildOfflineCheckoutOrder = ({
    productsArr,
    currentPriceList,
    market,
    orderId,
    paymentForm,
    orderType,
}: BuildOfflineCheckoutOrderProps): CheckoutOrder => {
    const { id, name, partner, address, contragent } = market;

    const products = productsArr.reduce(
        (acc, product) => {
            acc[product.barcode] = {
                ...product,
                price: currentPriceList?.[product.barcode]?.price,
            };
            return acc;
        },
        {} as CheckoutOrder["products"],
    );

    return {
        marketId: id,
        marketName: name,
        partner: partner.name,
        address: address.name,
        contragent: contragent.name,
        orderId,
        orderType,
        products: products,
        paymentForm,
        shipmentDate: "",
        customShipmentDate: "",
        id: "",
        comments: [],
        isCarrier: false,
        isSelfDelivery: false,
        creationDate: "",
        paymentDate: "",
        amount: 0,
        debt: 0,
        closed: false,
        isCredit: true,
    };
};
